const DEFAULT_SEARCH_RADIUS_METERS = 2000;
const MIN_SEARCH_RADIUS_METERS = 500;
const MAX_SEARCH_RADIUS_METERS = 10000;
const EARTH_RADIUS_METERS = 6371000;

const isValidCoordinate = (value, min, max) => {
  if (value === null || value === undefined || value === '' || typeof value === 'boolean') return false;
  const number = Number(value);
  return Number.isFinite(number) && number >= min && number <= max;
};

const normalizeOrigin = (latitude, longitude) => {
  if (!isValidCoordinate(latitude, -90, 90) || !isValidCoordinate(longitude, -180, 180)) {
    return null;
  }

  return {
    latitude: Number(latitude),
    longitude: Number(longitude),
  };
};

const distanceInMeters = (origin, point) => {
  const target = normalizeOrigin(point?.lat, point?.lng);
  if (!target) return null;

  const toRadians = (degrees) => degrees * Math.PI / 180;
  const latitudeDelta = toRadians(target.latitude - origin.latitude);
  const longitudeDelta = toRadians(target.longitude - origin.longitude);
  const originLatitude = toRadians(origin.latitude);
  const targetLatitude = toRadians(target.latitude);
  const haversine =
    Math.sin(latitudeDelta / 2) ** 2 +
    Math.cos(originLatitude) * Math.cos(targetLatitude) * Math.sin(longitudeDelta / 2) ** 2;

  return EARTH_RADIUS_METERS * 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine));
};

export const resolveGymSearchOrigin = (map, userLocation) => {
  const mapCenter = map?.getCenter?.();
  const visibleOrigin = normalizeOrigin(mapCenter?.lat, mapCenter?.lng);
  if (visibleOrigin) return visibleOrigin;

  return normalizeOrigin(userLocation?.latitude, userLocation?.longitude);
};

export const resolveGymSearchArea = (map, userLocation) => {
  const origin = resolveGymSearchOrigin(map, userLocation);
  if (!origin) return null;

  const bounds = map?.getBounds?.();
  const cornerDistances = [bounds?.getNorthEast?.(), bounds?.getSouthWest?.()]
    .map((corner) => distanceInMeters(origin, corner))
    .filter(Number.isFinite);
  const visibleRadius = cornerDistances.length
    ? Math.max(...cornerDistances)
    : DEFAULT_SEARCH_RADIUS_METERS;
  const roundedRadius = Math.ceil(visibleRadius / 100) * 100;

  return {
    ...origin,
    radius: Math.max(
      MIN_SEARCH_RADIUS_METERS,
      Math.min(MAX_SEARCH_RADIUS_METERS, roundedRadius)
    ),
  };
};
